import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import ProjectList from '../../project/ProjectList';

const AdminStaffProjectList: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // 判断当前角色
  const isAdmin = user?.role === 'admin';
  const isStaff = user?.role === 'staff';

  // 直接使用客户后台的项目列表组件
  // 通过 useAuth 自动判断角色权限
  return <ProjectList />;
};

export default AdminStaffProjectList; 